import React from 'react';

import {
  DrawerContentType,
  useWorkspaceDrawerContext,
} from '../WorkspaceDrawerContextProvider';
import {useSectionSettingOverrides} from './hooks/useSettingOverrides';
import {LinePlotSettings} from './runLinePlots/LinePlotSettings';
import {LinePlotSettingsContextProvider} from './runLinePlots/LinePlotSettingsContextProvider';
import {
  SectionSettingsContextProvider,
  useSectionSettingsContext,
} from './SectionSettingsContextProvider';

export const SectionSettingsContent = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  const {targetSectionRef} = useWorkspaceDrawerContext();
  if (targetSectionRef == null) {
    return null;
  }

  return (
    <SectionSettingsContextProvider sectionRef={targetSectionRef}>
      <SectionComponent displayedContentType={displayedContentType} />
    </SectionSettingsContextProvider>
  );
};

const SectionComponent = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  const {
    inheritedSettings,
    linePlot: sectionLinePlotSettings,
    trackSectionSettingChange,
    updateLinePlotSectionSettings,
  } = useSectionSettingsContext();

  const {clearSetting, settingOverrideCounts} = useSectionSettingOverrides();

  return (
    <LinePlotSettingsContextProvider
      clearSetting={clearSetting}
      displayLinePlotSettings={inheritedSettings.linePlot}
      linePlotSettings={sectionLinePlotSettings}
      settingOverrideCounts={settingOverrideCounts}
      settingLevel="section"
      trackLinePlotSetting={trackSectionSettingChange}
      updateLinePlotSettings={updateLinePlotSectionSettings}>
      <LinePlotSettings
        contentHeader={
          <h2 className="text-sm font-semibold leading-[22px] text-moon-500">
            SECTION SETTINGS
          </h2>
        }
        displayedContentType={displayedContentType}
      />
    </LinePlotSettingsContextProvider>
  );
};
